module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"THEORY_OF_CHANGE":"Impact Strategy & Impact Carry"},"de":{"THEORY_OF_CHANGE":"Impact Strategy & Impact Carry"}}')
  delete Component.options._Ctor
}
